import { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Row, Button } from 'react-bootstrap';
import { isEmpty } from 'lodash';
import PipEposSubmissionsFormDeclineDialog from './pip-epos-submissions-form-decline-dialog';
import { declinePipEposSubmission, validatePipEposSubmission } from '../../../../actions/pip-epos-submissions';
import { checkPermission } from '../../../common/guards/can';
import { isAdminLoggedIn } from '../../../../utils/sessionAreas';
import TextInput from '../../../common/form/elements/text-input';
import PipEposSubmissionsFormProofOfPurchase from './pip-epos-submissions-form-proof-of-purchase';

import './styles.css';
import { weekOfSaleDate } from '../../../../utils/commonFunctions';

class PipEposSubmissionsForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isDialogOpen: false
    };
  }

  handleOpenDialog = () => {
    this.setState({ isDialogOpen: true });
  };

  handleCloseDialog = () => {
    this.setState({ isDialogOpen: false });
  };

  handleValidate = () => {
    const { dispatch, id, formData } = this.props;

    dispatch(validatePipEposSubmission(id, formData));
  };

  handleDecline = (result) => {
    const {
      dispatch,
      id,
      declineReason,
      formData
    } = this.props;
    const data = {
      decline_reason: declineReason,
      ...formData
    };

    delete data.notes;

    if (result) {
      dispatch(declinePipEposSubmission(id, data));
      this.handleCloseDialog();
    } else {
      this.handleCloseDialog();
    }
  };

  render() {
    const { pipEposSubmission, model, formData: { notes } } = this.props;
    const { isDialogOpen } = this.state;
    const hasPermission = checkPermission('manage', 'PipEposSubmission');

    if (isEmpty(pipEposSubmission)) {
      return <div>Loading...</div>;
    }

    const isDeclined = pipEposSubmission.attributes.status === 'DECLINED';
    const isValidated = pipEposSubmission.attributes.status === 'VALIDATED';
    const hasSubmissionNotes = !(notes === null || notes === '');

    return (
      <div>
        <div className='mg-bottom-60 mg-top-10'>
          <div className="container-fluid">
            <div className="form-text-container">
              <Row>
                <Col md={6}>
                  <div>
                    <b>Status:</b> {pipEposSubmission.attributes.status}
                  </div>
                  <div>
                    <b>Customer Number:</b> {pipEposSubmission.attributes['customer-number']}
                  </div>
                  <div>
                    <b>Outlet name:</b> {pipEposSubmission.attributes['outlet-name']}
                  </div>
                  <div>
                    <b>SKU code:</b> {pipEposSubmission.attributes['sku-code']}
                  </div>
                  <div>
                    <b>Product name:</b> {pipEposSubmission.attributes['product-name']}
                  </div>
                  <div>
                    <b>Brand name:</b> {pipEposSubmission.attributes['brand-name']}
                  </div>
                  <div>
                    <b>Postcodeplan Objective name:</b> {pipEposSubmission.attributes['postcodeplan-objective-name']}
                  </div>
                  <div>
                    <b>Wholesaler Group name:</b> {pipEposSubmission.attributes['wholesaler-group-name'] || '-'}
                  </div>
                  <div>
                    <b>Week of Sale:</b> {weekOfSaleDate(pipEposSubmission.attributes['week-of-sale'])}
                  </div>
                  <div>
                    <b>Quantity:</b> {pipEposSubmission.attributes.quantity}
                  </div>
                  <div>
                    <b>Mode price:</b> {pipEposSubmission.attributes['mode-price'] || '-'}
                  </div>
                  <div>
                    <b>Shelf price:</b> {pipEposSubmission.attributes['shelf-price'] || '-'}
                  </div>
                  <div>
                    <b>Points per Pack:</b> {pipEposSubmission.attributes.points || '-'}
                  </div>
                  <div>
                    <b>Points to be Paid:</b> {pipEposSubmission.attributes['reward-value'] || '-'}
                  </div>
                  <div>
                    <b>Decline reason:</b> {pipEposSubmission.attributes['decline-reason'] || '-'}
                  </div>
                </Col>
                <Col md={6}>
                  <div>
                    <TextInput
                      label="Submission notes"
                      model={`${model}.notes`}
                    />
                  </div>
                  <div>
                    <PipEposSubmissionsFormProofOfPurchase model={model} />
                  </div>
                </Col>
                <Col md={12} className="ta-right">
                  <Button
                    className="red-ghost-btn"
                    disabled={isValidated || !hasPermission || !hasSubmissionNotes || (!isAdminLoggedIn() && isDeclined)}
                    onClick={this.handleValidate}
                  >
                    Validate
                  </Button>
                  <Button
                    className="red-ghost-btn"
                    disabled={isDeclined || !hasPermission}
                    onClick={this.handleOpenDialog}
                  >
                    Decline
                  </Button>
                </Col>
              </Row>
            </div>
          </div>
        </div>
        {isDialogOpen && (
          <PipEposSubmissionsFormDeclineDialog
            onHandleDecline={this.handleDecline}
            isValidated={isValidated}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  pipEposSubmission: state.pipEposSubmissions.pipEposSubmission,
  declineReason: state.deep.forms.admin_pip_epos_submissions_form_decline_dialog.decline_reason.value,
  formData: state.deep.admin_pip_epos_submissions
});

export default connect(mapStateToProps)(PipEposSubmissionsForm);
